export const DETAIL_CONTENT_HTML_IDS = [
    'content-info',
    'content-contact',
    'content-competition',
    'content-documents',
    'content-certificates'
];
